import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Experience, ExperienceQuote, ExperienceQuoteRequest } from './experience.types';

@Injectable()
export class ExperienceService {
	private readonly experienceUrl = 'api/experiences';

	constructor(private _http: HttpClient) { }

	getExperience(experienceId: number): Promise<Experience> {
		return this._http.get<Experience>(`${this.experienceUrl}/${experienceId}`)
			.toPromise();
	}

	getQuote(experienceId: number, request: ExperienceQuoteRequest): Promise<ExperienceQuote> {
		return this._http.post<ExperienceQuote>(`${this.experienceUrl}/${experienceId}/quotes`, request)
			.toPromise();
	}
}
